module.exports = __webpack_public_path__ + "img/19.eb397701.gif";